import React from 'react'

export class UsuarioEmpresaBloqueioItinerario extends React.Component {

    render() {
        return (
            <tr>
                <td>
                    {this.props.usuario.label}
                </td>
                <td className='text-center' style={{ cursor: 'pointer', color: 'red' }}>
                    <div onClick={() => this.props.removerUsuarioEmpresaBloqueio(this.props.usuario.value)}>Remover</div>
                </td>
            </tr>
        )
    }
}

export default UsuarioEmpresaBloqueioItinerario
